import React, { Component } from 'react'
import {
    Route,
    Redirect,
} from 'react-router-dom'
import {
    authedUserConnect,
    withRouter,
} from '../../validator'
import { isSuperAdmin } from '../../super-admin/helpers'

@withRouter()
@authedUserConnect()
export default class SuperAdminRoute extends Component {
    /**
     * Check if can be route redirected into login for non authed user
     * @return {boolean}
     */
    isSuperAdmin = () => {
        const { authedUser } = this.props
        return isSuperAdmin(authedUser)
    }

    /**
     * Render super admin route
     * @return {*}
     */
    render() {
        if (!this.isSuperAdmin()) {
            return <Redirect to='/login' />
        }

        return <Route {...this.props} />
    }
}
